import {
  Flex,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Text,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import { AIRDROP_VAULT_STRINGS } from "../constants";
import { Overview, Strategies } from "@components/VaultOverview";
import { AirdropVaultPageContext } from "@providers/AirdropVaultProvider";

const TABS_DATA = AIRDROP_VAULT_STRINGS.SECTIONS.OVERVIEW.TABS;
const OVERVIEW_DATA = AIRDROP_VAULT_STRINGS.SECTIONS.OVERVIEW.DATA;
const STRATEGIES_DATA = AIRDROP_VAULT_STRINGS.SECTIONS.OVERVIEW.STRATEGIES;

const VaultOverview = () => {
  const { cmsAllocations } = useContext(AirdropVaultPageContext);
  return (
    <Flex
      flexDir="column"
      gap="16px"
      w="100%"
      maxW={{ md: "736px", xl: "736px" }}
    >
      <Flex
        flexDir="column"
        pt="4px"
        pb="10px"
        gap="40px"
        borderRadius="24px"
        bg="#EBF9F9"
      >
        <Tabs>
          <TabList fontWeight="600" lineHeight="24px" overflowX="auto">
            {TABS_DATA.map((data) => (
              <Tab
                fontSize={{ base: "12px", xl: "14px" }}
                key={data.key}
                py="8px"
              >
                <Text>{data.title}</Text>
              </Tab>
            ))}
          </TabList>

          <TabPanels mt={{ base: "10px", xl: "12px" }}>
            <TabPanel>
              <Overview data={OVERVIEW_DATA} />
            </TabPanel>

            <TabPanel p="6px">
              <Strategies
                columns={STRATEGIES_DATA.COLUMNS}
                rows={STRATEGIES_DATA.ROWS}
                cmsAllocations={cmsAllocations?.allocations || []}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Flex>
  );
};

export default VaultOverview;
